import { createTheme } from '@mui/material';

export const darkTheme = createTheme({
  palette: {
    mode: 'dark'
  }
});

export const lightTheme = createTheme({
  transitions: {
    duration: {
      enteringScreen: 50
    }
  },
  palette: {
    mode: 'light',
    common: {
      black: 'var(--black)',
      white: 'var(--white)'
    },
    primary: {
      main: '#1976d2',
      light: '#42a5f5',
      dark: '#1565c0',
      contrastText: 'var(--white)'
    },
    secondary: {
      main: '#9c27b0',
      light: '#ba68c8',
      dark: '#7b1fa2',
      contrastText: 'var(--white)'
    }
  },
  components: {
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true
      }
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          fontSize: '14px',
          margin: '0'
        }
      }
    },
    MuiGrid: {
      styleOverrides: {
        item: {
          paddingLeft: '0px'
        }
      }
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          textTransform: 'unset',
          borderRadius: '6px',
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.5)'
          }
        }
      }
    },
    MuiButton: {
      defaultProps: {
        disableRipple: true
      },
      styleOverrides: {
        root: {
          textTransform: 'unset',
          boxShadow: 'unset',
          padding: '0',
          '&:hover': {
            boxShadow: 'unset'
          }
        }
      }
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: 'var(--white)',
            color: '#3761f4',
            borderColor: '#3761f4',
            borderRightWidth: '4px'
          },
          '&.Mui-selected:hover': {
            backgroundColor: 'var(--white)'
          }
        }
      }
    },
    MuiTab: {
      styleOverrides: {
        root: {
          color: 'var(--white)',
          backgroundColor: '#585858',
          borderTopRightRadius: '8px',
          borderTopLeftRadius: '8px',
          minHeight: '45px',
          fontSize: '12px',
          textTransform: 'unset'
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          boxShadow: '0px 6px 15px rgba(12, 24, 31, 0.03)'
        }
      }
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: 'var(--neutral900)',
          color: 'var(--white)',
          /* PRD-19926 
            Tooltip selecability will cause odd highlight behavior on iPad
            It has been identified that this is "0-value" functionality, so it is being globally disabled
          */
          userSelect: 'none'
        },
        arrow: {
          '&:before': {
            backgroundColor: 'var(--neutral900)'
          }
        }
      }
    },
    MuiDialog: {
      styleOverrides: {
        root: {
          '&.MuiDialog-root': {
            '.MuiPaper-root': {
              borderWidth: '1px',
              borderStyle: 'solid',
              borderColor: 'var(--neutral300)'
            }
          }
        }
      }
    },
    MuiMenu: {
      styleOverrides: {
        root: {
          '&.MuiPopover-root': {
            '.MuiPaper-root': {
              borderWidth: '1px',
              borderStyle: 'solid',
              borderColor: 'var(--neutral300)',

              '.MuiMenuItem-root': {
                '&:hover': {
                  backgroundColor: 'var(--neutral100)'
                }
              }
            }
          }
        }
      }
    },
    MuiPopover: {
      styleOverrides: {
        root: {
          '&.MuiPopover-root': {
            '.MuiPaper-root': {
              borderWidth: '1px',
              borderStyle: 'solid',
              borderColor: 'var(--neutral300)'
            }
          }
        }
      }
    }
  }
});
